// extracted by mini-css-extract-plugin
export default {"container":"StepText_container__iS693","callout":"StepText_callout__N8CAc"};